import axios from "./axios"

export default {
    login(email, pwd) {
        return axios.post(process.env.VUE_APP_AUTH_URL + "/api/auth/login", {email: email, password: pwd})
    },
    logout() {
        return axios.post(process.env.VUE_APP_AUTH_URL + "/api/auth/logout")
    },
    registerUser(first_name, second_name, email, pwd) {
        return axios.post(process.env.VUE_APP_AUTH_URL + "/api/auth/register", {first_name: first_name, second_name: second_name, email: email, password: pwd})
    },
    refreshToken() {
        return axios.post(process.env.VUE_APP_AUTH_URL + "/api/auth/refresh-token", {accessToken: localStorage.getItem("accessToken")})
    },
    userData() {
        return new Promise(function(resolve, reject) {
            axios.get(process.env.VUE_APP_AUTH_URL + "/api/auth/user").then(res => {resolve(res.data.data);}).catch(err => {reject(err);})
        });
    },
    loadAvatar(fd) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_AUTH_URL + "/api/user/avatar", fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {resolve(res.data.data);}).catch(err => {reject(err);})
        });
    },
    updateUser(user) {
        return new Promise(function(resolve, reject) {
            axios.patch(`${process.env.VUE_APP_AUTH_URL}/api/user/${user.id}`, user).then(res => {resolve(res.data.data);}).catch(err => {reject(err);})
        });
    },
    changePassword(payload) {
        return new Promise(function(resolve, reject) {
            axios.post(`${process.env.VUE_APP_AUTH_URL}/api/user/change-password`, payload).then(res => {resolve(res.data.data);}, err => reject(err.response))
        });
    }
}
